import { Heading } from '../components_catalyst/heading';
import { Text } from '../components_catalyst/text';
import { Link } from '../components_catalyst/link';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function MembershipPage() {
  useDocumentTitle('Membership', { addSuffix: true });

  return (
    <main className="max-w-4xl mx-auto space-y-6 p-4">
      <Heading level={1}>Membership</Heading>

      <div className="space-y-4">
        <Text>
          Thanks for your interest! MilestoneMap.org membership is currently by invitation only.{' '}
          <Link
            href="https://forms.gle/XiD613ySc8QHoKrC9"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline decoration-2 decoration-blue-600/30 hover:decoration-blue-800"
            aria-label="Sign up for the MilestoneMap.org wait-list (opens in new tab)"
          >
            Sign up here to join the wait-list
          </Link>
          .
        </Text>

        <Text>We're developing plans for individual, organization, and enterprise membership:</Text>

        <ul className="list-disc pl-6 space-y-2" aria-label="Membership plan descriptions">
          <li>
            <Text>
              <span className="font-semibold">Individual members</span>{' '}
              <span>can create maps and invite guests to collaborate</span>
            </Text>
          </li>
          <li>
            <Text>
              <span className="font-semibold">Organizations</span>{' '}
              <span>own and manage maps created by their organization's members</span>
            </Text>
          </li>
          <li>
            <Text>
              <span className="font-semibold">Enterprise</span>{' '}
              <span>instances are available for unlimited members and organizations</span>
            </Text>
          </li>
        </ul>
      </div>
    </main>
  );
}
